// Referral code helpers — capture ?ref= from URL, persist in sessionStorage,
// so it survives navigation before the user submits the waitlist form.
const REF_KEY = "ce_ref";

export function captureReferral() {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  const ref = params.get("ref");
  if (ref) sessionStorage.setItem(REF_KEY, ref);
}

export function getReferral() {
  try { return sessionStorage.getItem(REF_KEY) || null; } catch { return null; }
}
